import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { getAgreementAccepted } from '../../services';
import { EButtonType } from '../../types';
import { BrokerAlreadyRegisteredModal, BrokerConfirmationModal, BrokerDescriptionModal, BrokerErrorModal, BrokerFetchingModal, BrokerRedirectModal } from './parts';
import { useBrokerLinkFetcher, useModalControl } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NewbuildingBrokerModalWindow = function NewbuildingBrokerModalWindow(_ref) {
  var renderModalOpener = _ref.renderModalOpener,
    personalDataAgreementLink = _ref.personalDataAgreementLink,
    landingUrl = _ref.landingUrl,
    newbuildingId = _ref.newbuildingId,
    newbuildingRegionId = _ref.newbuildingRegionId,
    houseId = _ref.houseId,
    isSelfEmployed = _ref.isSelfEmployed,
    onModalOpenerClick = _ref.onModalOpenerClick,
    onRewardInstructionButtonClick = _ref.onRewardInstructionButtonClick,
    onRewardInstructionLinkClick = _ref.onRewardInstructionLinkClick,
    onBrokerLinkFetched = _ref.onBrokerLinkFetched,
    onErrorModalOpen = _ref.onErrorModalOpen,
    onRetryButtonClick = _ref.onRetryButtonClick;
  var _useModalControl = useModalControl(),
    isDescriptionModalOpen = _useModalControl.isDescriptionModalOpen,
    isConfirmationModalOpen = _useModalControl.isConfirmationModalOpen,
    isFetchingModalOpen = _useModalControl.isFetchingModalOpen,
    isErrorModalOpen = _useModalControl.isErrorModalOpen,
    isAlreadyRegisteredModalOpen = _useModalControl.isAlreadyRegisteredModalOpen,
    isRedirectModalOpen = _useModalControl.isRedirectModalOpen,
    openDescriptionModal = _useModalControl.openDescriptionModal,
    openConfirmatioModal = _useModalControl.openConfirmatioModal,
    openFetchingModal = _useModalControl.openFetchingModal,
    openErrorModal = _useModalControl.openErrorModal,
    openAlreadyRegisteredModal = _useModalControl.openAlreadyRegisteredModal,
    openRedirectModal = _useModalControl.openRedirectModal,
    closeDescriptionModal = _useModalControl.closeDescriptionModal,
    closeConfirmatioModal = _useModalControl.closeConfirmatioModal,
    closeFetchingModal = _useModalControl.closeFetchingModal,
    closeErrorModal = _useModalControl.closeErrorModal,
    closeAlreadyRegisteredModal = _useModalControl.closeAlreadyRegisteredModal,
    closeRedirectModal = _useModalControl.closeRedirectModal;
  var _useBrokerLinkFetcher = useBrokerLinkFetcher({
      newbuildingId: newbuildingId,
      newbuildingRegionId: newbuildingRegionId,
      houseId: houseId,
      openFetchingModal: openFetchingModal,
      closeFetchingModal: closeFetchingModal,
      openRedirectModal: openRedirectModal,
      openErrorModal: openErrorModal,
      openAlreadyRegisteredModal: openAlreadyRegisteredModal,
      onErrorModalOpen: onErrorModalOpen
    }),
    brokerName = _useBrokerLinkFetcher.brokerName,
    brokerUrl = _useBrokerLinkFetcher.brokerUrl,
    fetchAndOpenBrokerLink = _useBrokerLinkFetcher.fetchAndOpenBrokerLink;
  var handleBrokerButtonClick = React.useCallback(function () {
    if (getAgreementAccepted()) {
      openConfirmatioModal();
    } else {
      openDescriptionModal();
    }
    if (onModalOpenerClick) {
      onModalOpenerClick();
    }
  }, [openConfirmatioModal, openDescriptionModal, onModalOpenerClick]);
  var handleNextClick = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          closeDescriptionModal();
          _context.next = 3;
          return fetchAndOpenBrokerLink();
        case 3:
          result = _context.sent;
          if (onBrokerLinkFetched) {
            onBrokerLinkFetched(EButtonType.Next, result);
          }
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [closeDescriptionModal, fetchAndOpenBrokerLink, onBrokerLinkFetched]);
  var handleReadyClick = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          closeConfirmatioModal();
          _context2.next = 3;
          return fetchAndOpenBrokerLink();
        case 3:
          result = _context2.sent;
          if (onBrokerLinkFetched) {
            onBrokerLinkFetched(EButtonType.Go, result);
          }
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [closeConfirmatioModal, fetchAndOpenBrokerLink, onBrokerLinkFetched]);
  var handleRewardInstructionLinkClick = React.useCallback(function () {
    if (onRewardInstructionLinkClick) {
      onRewardInstructionLinkClick();
    }
  }, [onRewardInstructionLinkClick]);
  var handleRewardInstructionButtonClick = React.useCallback(function () {
    if (onRewardInstructionButtonClick) {
      onRewardInstructionButtonClick();
    }
  }, [onRewardInstructionButtonClick]);
  var handleRetryClick = React.useCallback(function () {
    closeErrorModal();
    fetchAndOpenBrokerLink();
    if (onRetryButtonClick) {
      onRetryButtonClick();
    }
  }, [closeErrorModal, fetchAndOpenBrokerLink, onRetryButtonClick]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderModalOpener({
      onClick: handleBrokerButtonClick
    }), /*#__PURE__*/_jsx(BrokerDescriptionModal, {
      isOpen: isDescriptionModalOpen,
      isSelfEmployedCheckboxVisible: isSelfEmployed,
      landingUrl: landingUrl,
      onClose: closeDescriptionModal,
      onNext: handleNextClick,
      onRewardInstructionLinkClick: handleRewardInstructionLinkClick,
      personalDataAgreementLink: personalDataAgreementLink
    }), /*#__PURE__*/_jsx(BrokerConfirmationModal, {
      isOpen: isConfirmationModalOpen,
      landingUrl: landingUrl,
      onClose: closeConfirmatioModal,
      onReadyClick: handleReadyClick,
      onRewardInstructionButtonClick: handleRewardInstructionButtonClick
    }), /*#__PURE__*/_jsx(BrokerAlreadyRegisteredModal, {
      brokerName: brokerName,
      isOpen: isAlreadyRegisteredModalOpen,
      onClose: closeAlreadyRegisteredModal
    }), /*#__PURE__*/_jsx(BrokerFetchingModal, {
      isOpen: isFetchingModalOpen,
      onClose: closeFetchingModal
    }), /*#__PURE__*/_jsx(BrokerErrorModal, {
      isOpen: isErrorModalOpen,
      onClose: closeErrorModal,
      onRetry: handleRetryClick
    }), /*#__PURE__*/_jsx(BrokerRedirectModal, {
      isOpen: isRedirectModalOpen,
      onClose: closeRedirectModal,
      brokerUrl: brokerUrl
    })]
  });
};